import React from "react";

export const PlayIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83325 5.00065C7.83325 3.80403 8.8033 2.83398 9.99992 2.83398C11.1965 2.83398 12.1666 3.80403 12.1666 5.00065C12.1666 6.19727 11.1965 7.16732 9.99992 7.16732C8.8033 7.16732 7.83325 6.19727 7.83325 5.00065ZM9.99992 1.33398C7.97487 1.33398 6.33325 2.97561 6.33325 5.00065C6.33325 6.76866 7.58459 8.2444 9.24992 8.59055V10.834C9.24992 11.2482 9.5857 11.584 9.99992 11.584C10.4141 11.584 10.7499 11.2482 10.7499 10.834V8.59055C12.4153 8.2444 13.6666 6.76866 13.6666 5.00065C13.6666 2.97561 12.025 1.33398 9.99992 1.33398ZM4.99992 11.334C5.41413 11.334 5.74992 11.6698 5.74992 12.084V12.584H15.1666C16.4092 12.584 17.4166 13.5913 17.4166 14.834V16.0007C17.4166 17.2433 16.4092 18.2507 15.1666 18.2507H4.83325C3.59061 18.2507 2.58325 17.2433 2.58325 16.0007V14.834C2.58325 13.7931 3.29007 12.9173 4.24992 12.6603V12.084C4.24992 11.6698 4.58571 11.334 4.99992 11.334ZM4.99992 14.084H4.83325C4.41904 14.084 4.08325 14.4198 4.08325 14.834V16.0007C4.08325 16.4149 4.41904 16.7507 4.83325 16.7507H15.1666C15.5808 16.7507 15.9166 16.4149 15.9166 16.0007V14.834C15.9166 14.4198 15.5808 14.084 15.1666 14.084H4.99992Z"
      fill="#8F918D"
    />
  </svg>
);
